import React from "react";
import BrokerPartnerRefundNotice from "components/legal/BrokerPartnerRefundNotice";
import LegalFooterBannerAndLinks from "components/legal/LegalFooterBannerAndLinks";
import LegalPagesBrandHeader from "components/legal/LegalPagesBrandHeader";
import { LEGAL_PAGES_LAST_UPDATED } from "legal/legalMeta";
import {
  REFUND_ELIGIBLE,
  REFUND_EXAMPLE,
  REFUND_GUARANTEE_SCOPE_PARAGRAPHS,
  REFUND_HOW_TO_REQUEST,
  REFUND_NOT_ELIGIBLE,
  REFUND_OPEN_TRADES,
  REFUND_TRADING_RESULTS_DISCLAIMER,
} from "legal/refundPolicyContent";

export default function RefundPolicy() {
  return (
    <main className="min-h-screen bg-[#0B1437] px-5 py-6 text-white sm:py-8">
      <div className="mx-auto w-full max-w-5xl">
        <LegalPagesBrandHeader />
        <header className="mb-5 space-y-2 text-center">
          <h1 className="text-3xl font-bold sm:text-4xl">Refund Policy</h1>
          <p className="text-sm text-gray-300">Last updated: {LEGAL_PAGES_LAST_UPDATED}</p>
          <p className="mx-auto max-w-3xl text-sm leading-relaxed text-gray-300 sm:text-base">
            We offer a 30-day satisfaction guarantee for the first subscription
            month, with clear and measurable eligibility criteria.
          </p>
        </header>

        <BrokerPartnerRefundNotice className="mb-6" />

        <section className="space-y-4">
          <article className="rounded-2xl border border-white/10 bg-white/[0.04] p-5 sm:p-6">
            <h2 className="text-lg font-semibold text-white">30-Day Guarantee Scope</h2>
            {REFUND_GUARANTEE_SCOPE_PARAGRAPHS.map((para) => (
              <p key={para} className="mt-2 text-sm leading-relaxed text-gray-300 sm:text-base">
                {para}
              </p>
            ))}
            <p className="mt-3 rounded-xl border border-white/10 bg-[#0a102c]/60 p-3 text-sm text-gray-200">
              {REFUND_EXAMPLE}
            </p>
          </article>

          <article className="rounded-2xl border border-emerald-300/20 bg-emerald-500/[0.06] p-5 sm:p-6">
            <h2 className="text-lg font-semibold text-emerald-200">
              Eligible for Refund
            </h2>
            <ul className="mt-3 space-y-2 text-sm leading-relaxed text-emerald-100/90 sm:text-base">
              {REFUND_ELIGIBLE.map((item) => (
                <li key={item}>• {item}</li>
              ))}
            </ul>
          </article>

          <article className="rounded-2xl border border-amber-300/20 bg-amber-500/[0.06] p-5 sm:p-6">
            <h2 className="text-lg font-semibold text-amber-200">
              Non-Refundable Situations
            </h2>
            <ul className="mt-3 space-y-2 text-sm leading-relaxed text-amber-100/90 sm:text-base">
              {REFUND_NOT_ELIGIBLE.map((item) => (
                <li key={item}>• {item}</li>
              ))}
            </ul>
          </article>

          <article className="rounded-2xl border border-white/10 bg-white/[0.04] p-5 sm:p-6">
            <h2 className="text-lg font-semibold text-white">
              Open Trades at Subscription Expiry
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-gray-300 sm:text-base">
              {REFUND_OPEN_TRADES}
            </p>
          </article>

          <article className="rounded-2xl border border-white/10 bg-white/[0.04] p-5 sm:p-6">
            <h2 className="text-lg font-semibold text-white">How to Request a Refund</h2>
            <ol className="mt-3 space-y-2 text-sm leading-relaxed text-gray-300 sm:text-base">
              {REFUND_HOW_TO_REQUEST.map((item, idx) => (
                <li key={item}>
                  {idx + 1}. {item}
                </li>
              ))}
            </ol>
          </article>

          <article className="rounded-2xl border border-white/10 bg-white/[0.04] p-5 sm:p-6">
            <h2 className="text-lg font-semibold text-white">
              Trading Results Disclaimer
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-gray-300 sm:text-base">
              {REFUND_TRADING_RESULTS_DISCLAIMER}
            </p>
          </article>
        </section>

        <footer className="mt-8 border-t border-white/10 pt-5 text-xs text-gray-400 sm:text-sm">
          <p className="text-center">
            By using AlphaSniper Trading services, you acknowledge that you have
            read and accepted this Refund Policy.
          </p>
          <p className="mt-4 text-center">
            AlphaSniper 2026 © All Rights Reserved
          </p>
          <LegalFooterBannerAndLinks />
        </footer>
      </div>
    </main>
  );
}
